import Link from "next/link"
import { cn } from "@/shared/lib/utils"

interface TeksBantuanProps {
  pengantar: string
  tautan: string
  href?: string
  className?: string
  onKlik?: () => void
}

export function TeksBantuan({ pengantar, tautan, href = "/help", className, onKlik }: TeksBantuanProps) {
  return (
    <p className={cn("text-xs text-muted-foreground", className)}>
      {pengantar}{" "}
      <Link href={href} onClick={onKlik} className="font-semibold text-primary hover:underline">
        {tautan}
      </Link>
    </p>
  )
}
